import type { StyleLayer } from './utils/types'

export const layers_parkingLars_stats: StyleLayer[] = [
  {
    id: 'area-0-to-100',
    type: 'fill',
    filter: ['has', 'admin_level'],
    paint: {
      'fill-color': [
        'interpolate',
        ['linear'],
        ['to-number', ['get', 'done_percent']],
        0,
        'rgb(195, 179, 255)',
        80,
        'rgb(122, 0, 163)',
      ],
      'fill-opacity': 0.35,
      'fill-outline-color': 'hsl(0, 100%, 100%)',
    },
  },
  {
    id: 'line',
    type: 'line',
    paint: {
      'line-color': 'hsl(0, 0%, 100%)',
      'line-opacity': 0.63,
    },
  },
  {
    id: 'label',
    type: 'symbol',
    layout: {
      'text-field': ['to-string', ['get', 'done_percent']],
    },
    paint: {
      'text-color': 'rgba(69, 0, 112, 0.95)',
      'text-halo-blur': 1,
      'text-halo-color': 'hsl(291, 0%, 100%)',
      'text-halo-width': 1,
    },
  },
]
